<script setup lang="ts">
import KpiIcon from '@/views/icons/KpiIcon.vue';
import {ElBadge} from 'element-plus';
import {computed} from 'vue';
import {badgeOffset} from '@/base/utils.js';

const props = defineProps({
    to: {
        type    : String,
        required: true,
    },
    name           : String,
    icon           : String,
    badgeValue     : Number,
    badgeColor     : String,
    badgeExtraValue: Number,
    badgeExtraColor: String,
});

const badgeString      = computed<string>(() =>
    props.badgeValue === -1
        ? ''
        : props.badgeValue === 0 && props.badgeExtraValue
            ? '0'
            : props.badgeValue
                ? props.badgeValue.toString()
                : '',
);
const badgeExtraString = computed<string>(() =>
    props.badgeExtraValue === -1
        ? ''
        : props.badgeExtraValue
            ? props.badgeExtraValue.toString()
            : '',
);

function myBadgeOffset(extra: boolean): [number, number] {
    return badgeOffset([0, -8], extra, props.badgeValue, props.badgeExtraValue);
}

</script>

<template>
    <router-link
        :to="to"
        class="px-3 py-2 text-gray-700 border-gray-400 hover:border-gray-500 border-b-4 bg-stone-200"
        exact-active-class="!border-gray-700"
    >
        <el-badge
            :value="badgeString"
            :color="badgeColor"
            :offset="myBadgeOffset(false)"
            class="item"
            badge-class="font-normal"
        >
            <el-badge
                :value="badgeExtraString"
                :color="badgeExtraColor"
                :offset="myBadgeOffset(true)"
                class="item"
                badge-class="font-normal"
            >
                <div class="flex flex-row items-center">
                    <KpiIcon :name="icon" v-if="icon"/>
                    {{ name }}
                </div>
            </el-badge>
        </el-badge>
    </router-link>
</template>
